import { render } from "./dl-modal.vue?vue&type=template&id=596a0c2a"
import script from "./dl-modal.vue?vue&type=script&lang=js"
export * from "./dl-modal.vue?vue&type=script&lang=js"

import "./dl-modal.vue?vue&type=style&index=0&id=596a0c2a&lang=scss"

import exportComponent from "/var/www/doctolib-hos-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__